import React, { Component } from 'react'
import cn from 'classnames'

import { FEED_LINKS, TAB_LEADER_BOARD, TAB_STORIES, FEED_FILTER, FEED_FILTER_TEAMS } from 'app/constants/feed'
import { RUSSIAN, SPANISH, FRENCH } from 'app/constants/languages'
import { getTeamFilterOptions } from 'helpers/parseTeams'
import Select from 'app/components/Select'
import HoveredIcon from 'app/components/HoveredIcon'
import './styles.scss'

export const bc = 'feed-header'

class FeedHeader extends Component {
  componentDidMount() {
    this.setSliderStyles()
  }

  componentDidUpdate() {
    this.setSliderStyles()
  }

  setSliderStyles() {
    if (!this.wrap || !this.slider) {
      return
    }

    const activeTab = this.wrap.getElementsByClassName(`${bc}__item-active`)[0]
    const tabSizes = activeTab.getBoundingClientRect()
    const wrapSizes = this.wrap.getBoundingClientRect()

    this.slider.style.setProperty(
      'transform',
      `translateX(${tabSizes.left - wrapSizes.left - activeTab.scrollLeft}px) scaleX(${tabSizes.width})`
    )
  }

  render() {
    const {
      t,
      i18n: { language },
      tab,
      setTab,
      teams,
      fetchLeaderBoard,
      setFilterByTeam,
      byTeam,
      byRange,
      isOrganizationHasStories,
      isTeamOnly,
      showUnreadCounter,
    } = this.props

    const options = getTeamFilterOptions(isTeamOnly, teams)

    return (
      <div className={bc}>
        {!!teams.size &&
          ((isTeamOnly && teams.size > 1) || (!isTeamOnly && teams.size >= 1) ? (
            <div className={`${bc}__select-wrapper`}>
              <Select
                options={options}
                showLabel={false}
                getLabel={option => option.name}
                classNameSelect={`${bc}__select`}
                input={{
                  value: byTeam,
                  onChange: e => {
                    tab === TAB_LEADER_BOARD && fetchLeaderBoard({ team: e.target.value, range: byRange })
                    setFilterByTeam(e.target.value)
                  },
                }}
                styleSelect={{
                  maxWidth: `${
                    byTeam.length < 5
                      ? 60
                      : byTeam === FEED_FILTER && language === RUSSIAN
                      ? byTeam.length * 17
                      : language === SPANISH || language === FRENCH
                      ? byTeam.length * 22
                      : byTeam === FEED_FILTER_TEAMS
                      ? byTeam.length * 19
                      : byTeam.length * 13
                  }px`,
                }}
              />
            </div>
          ) : (
            <div className={`${bc}__team`}>{options[0].name}</div>
          ))}
        <div className={`${bc}__tabs`} ref={ref => (this.wrap = ref)}>
          {FEED_LINKS.map(link => {
            if (link.tab === TAB_STORIES && !isOrganizationHasStories) {
              return null
            }
            return (
              <span
                onClick={() => tab !== link.tab && setTab(link.tab)}
                key={link.tab}
                className={cn(`${bc}__item`, {
                  [`${bc}__item-active`]: link.tab === tab,
                })}
                id={link.tab}
              >
                <HoveredIcon
                  defaultIcon={link.icons.default}
                  activeIcon={link.icons.active}
                  label={t(link.title)}
                  iconClass={`${bc}__icon`}
                  active={link.tab === tab}
                />
                {link.tab === TAB_STORIES && showUnreadCounter > 0 && (
                  <span className={`${bc}__counter`}>{showUnreadCounter}</span>
                )}
              </span>
            )
          })}
        </div>
        <div className={`${bc}__slider`} ref={ref => (this.slider = ref)} />
      </div>
    )
  }
}

export default FeedHeader
